import {useMemo} from 'react';

export function useFormatPhone(phone: string) {
  return useMemo(() => {
    let trimmed = phone.trim();
    return `${trimmed.substring(0, 4)} ${trimmed.substring(4, 6)} ${trimmed.substring(6, 9)} ${trimmed.substring(9, 12)}`}, [phone]);
}
